
<section class="gallery">
  <div class="container gallery-container">

      

      <!-- 1st Album-->
      <div class="clearfix"></div>
      <div class="tz-gallery">
          <h1>{{albumTitle}}</h1>

          <div class="row justify-content-md-center">
              @for(photo of photos; track photo) {
                <div class="col-md-6 col-sm-12 deprecated-col-md-auto">
                    <div class="thumbnail">
                        <a class="lightbox" (click)="showImage(photo)">
                            <img [src]="photo.src" [alt]="photo.title">
                        </a>
                        @if(photo.title || photo.description) {
                        <div class="caption">
                            <h3>{{photo.title}}</h3>
                            <p>{{photo.description}}</p>
                        </div>
                        }
                    </div>
                </div>
              }

          </div>
        </div>
</div>

<ng-container>
  <div class="modal fade" [ngClass]="{ 'show' : showViewer}" data-backdrop="static" id="traditional" tabindex="-1" role="dialog">
    <div class="modal-dialog  modal-dialog-centered modal-xl" role="document">
        <div class="modal-content  bg-dark">
            <!-- Modal Header -->
            <div class="modal-header" (click)="closeImage()">
                
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" (click)="closeImage()"></button>
            </div>
            <!-- Modal body -->
            <div class="modal-body d-flex justify-content-center" >
              
              <img loading="lazy" [src]="previewImageSrc" class="img-fluid">
              <!-- <fa-icon [icon]="faChevronCircleLeft" class="backImage" (click)="lastImage()"></fa-icon>
              <fa-icon [icon]="faChevronCircleRight" class="forwardImage" (click)="nextImage()"></fa-icon> -->
            </div>
            <div class="modal-footer" (click)="closeImage()">
              <h2 class="justify-content-center modal-title font-w row">{{previewImageTitle}}</h2>
              <div class="row">{{previewImageDescription}}</div>
            </div>
        </div>
    </div>
</div>
</ng-container>

</section>